<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ttl2" id="c22" style="margin-top: 15%;">Thirteen</p>
<p class="tx1" style="margin-top: 7%;">A thick, heavy mist from the nearby swamp had risen to meet the South Carolina December dusk as a large-framed black woman left the big house. The lantern bobbing in her hand sent uneven light bouncing along the path as she made her way toward the slave cabins about half a mile away.</p>
<p class="tx">The woman called Amaritta did not tend every birth on the plantation. But poor Lucindy had been so despondent ever since the loss of her husband that Mistress Crawford was afraid the birthing might kill her. So she sent the housekeeper along to make sure nothing went wrong. Lucindy was too young and too valuable to lose that way. Nine months before the master had insisted that Amaritta check on Lucindy almost daily, anxious to know the instant “the business was done” as he called it, so he could get Caleb Eaton on the block and gone. Now that the time had run its course, he would take out his wrath on every woman of the place if she died in childbirth.</p>
<p class="tx">The black midwife from the slave village had already been inside Lucindy’s little shack for an hour when the housekeeper arrived. Even as Amaritta walked up the steps, another old black woman, one of the matriarchs of the slave community who helped hold together its family bonds, walked outside to meet her. The expression on her face did not bode well.</p>
<p class="tx">“Ah be too late… hit already come?” asked Amaritta.</p>
<p class="tx">“Dat it did,” answered the woman, “’bout ten minutes ago—but hit ain’t no man-chil’.”</p>
<p class="tx">Amaritta shook her head. “Dat ain’t good,” she said. “Massa’ll be parful upset by dat turn ob events.”</p>
<p class="tx">“’Deed he will,” assented the other. “He still got it out fo’ Lucindy on account er Caleb.”</p>
<p class="tx">“He’s likely only leab her alone fo’ two seasons at da mos’ fo’ he’ll be wantin’ ter put sum other man wif her ter git her wif chil’ agin.”</p>
<p class="tx">“Ah sure be glad dem days is dun gone fo’ me,” said the older woman, shaking her head.</p>
<p class="tx">“What we gwine do fo’ po’ Lucindy?” said the housekeeper. “We’s got ter do sumfin.”</p>
<p class="tx">“She ain’t strong enuf fo’ anuder baby dat soon, no how.”</p>
<p class="tx">“We gots ter do what we can t’ protec’ her.”</p>
<p class="tx">“Ah’m thinkin’ dat she’s be likely ter be gittin’ real sick long ’bout six months from now,” mused the matriarch.</p>
<p class="tx">Illuminated by the lantern, a knowing look passed between the two women in the night. A few silent nods followed.</p>
<p class="tx">“You know how it gits sumtime long ’bout den, wif nursin’ da baby takin’ all yo’ strenf, an’ how a woman gits weak an’ sick, an’ ain’t much good fo’ nuthin no how.”</p>
<p class="tx">“Da massa, he’ll be makin’ me come down an’ check when she’s ready,” said Amaritta.</p>
<p class="tx">“You kin check all right, an you’s boun’ ter fin’ her in a bad way, I’m thinkin’. Yes, sir… I’m thinkin’ dat it jus’ might be a sickness dat’ll keep her outta any man’s bed fo’a good long spell.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Thirteen.vue?6c567380